<template>
    <div class="modal animated fadeIn fixed z-50 pin overflow-auto bg-smoke-dark flex">
        <div class="animated fadeInUp fixed shadow-inner max-w-md md:relative pin-b pin-x align-top m-auto justify-end md:justify-center p-8 bg-white md:rounded w-full md:h-auto md:shadow flex flex-col">
            <form class="w-full max-w-sm">
                <slot></slot>
            </form>
            <span @click="toggle()" class="absolute pin-t pin-r pt-4 px-4" data-cy="closeModal">
                <svg class="h-12 w-12 text-grey hover:text-grey-darkest" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: ['mode'],
    data() {
        return {
            // localShow: this.show,
        };
    },
    methods: {
        toggle() {
            const commitHelper = this.mode === 'singlePayment' ? 'SET_SINGLEPAYMENT_MODAL' : 'SET_CURRENT_MODAL';
            // this.$emit('toggle');
            this.$store.commit(commitHelper, false);
            this.$store.commit('CLEAR_PAYMENT');
            // this.localShow = !this.localShow;
        },
    },
};
</script>

<style scoped>
.pin {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.bg-smoke-dark,
.hover\:bg-smoke-dark:hover {
  background-color: rgba(0, 0, 0, 0.6);
}

.pin-y {
  top: 0;
  bottom: 0;
}

.pin-x {
  right: 0;
  left: 0;
}
.pin-t {
  top: 0;
}

.pin-r {
  right: 0;
}

.pin-b {
  bottom: 0;
}

.pin-l {
  left: 0;
}
</style>
